const actions = {
    GET_ALL_TARIFFS: "tariff/GET_ALL_TARIFFS",
    SET_ALL_TARIFFS: "tariff/SET_ALL_TARIFFS",

    GET_TARIFFS_LOGS: "tariff/GET_TARIFFS_LOGS",
    SET_TARIFFS_LOGS: "tariff/SET_TARIFFS_LOGS",

    GET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE: "tariff/GET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE",
    SET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE: "tariff/SET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE",

    GET_TARIFF_LOG_DETAILS: "tariff/GET_TARIFF_LOG_DETAILS",
    SET_TARIFF_LOG_DETAILS: "tariff/SET_TARIFF_LOG_DETAILS",
};

export default actions;